export default __webpack_public_path__ + "8f3e5893da25fda9f4082fa43d6ea68b.wav";